module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pagination-nav"
  }, [_c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.meta.totalPage,
      "value": _vm.page
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dc050ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shades/pagination.vue
// module id = 3170
// module chunks = 0